import { render, staticRenderFns } from "./ComputerErased.vue?vue&type=template&id=6d954fd4&scoped=true&"
import script from "./ComputerErased.vue?vue&type=script&lang=js&"
export * from "./ComputerErased.vue?vue&type=script&lang=js&"
import style0 from "./ComputerErased.vue?vue&type=style&index=0&id=6d954fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d954fd4",
  null
  
)

export default component.exports